import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import store from '../store/store';
import { SET_ACCOUNT } from '../store/action-types';

const LOGOUT_IN_PROGRESS = 'logout_in_progress';

let $msalInstance: PublicClientApplication | null = null;
let $scopes: string[] = [];

const service = {
  $msalInstance,
  init() {
    const config = (window as any).appConfig;
    $msalInstance = new PublicClientApplication({
      auth: {
        clientId: config.AZUREABB2C_CLIENTID as string,
        authority: config.AZUREADB2C_AUTHORITY,
        knownAuthorities: [config.AZUREADB2C_KNOWN_AUTHORITY],
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
      },
    });
    $scopes = ['openid', 'offline_access', config.AZUREABB2C_FULL_ACCESS_SCOPE];
  },
  async handleRedirectPromise() {
    let outcome: boolean | string = false;

    const loggingOut = window.localStorage.getItem(LOGOUT_IN_PROGRESS);

    if (loggingOut) {
      window.localStorage.removeItem(LOGOUT_IN_PROGRESS);
      return 'logged_out';
    }

    try {
      const result = await $msalInstance?.handleRedirectPromise();

      if (result != null) {
        store.dispatch(SET_ACCOUNT, this.getAccount());
        outcome = true;
      } else {
        try {
          await this.getToken();
          outcome = true;
        } catch {
          outcome = false;
        }
      }
    } catch (error) {
      if (error.errorCode == 'invalid_grant') {
        $msalInstance?.acquireTokenRedirect({
          scopes: $scopes as string[],
          redirectUri: this.getHostname(),
        });
      }
      store.dispatch(SET_ACCOUNT, null);
      // Handle redirect error
      console.log(error);
      outcome = false;
    }

    return outcome;
  },
  getAccount(): AccountInfo | undefined {
    const accounts = $msalInstance?.getAllAccounts();

    if (!accounts || accounts.length === 0) {
      return undefined;
    } else {
      return accounts[0];
    }
  },
  getHostname() {
    return window.location.protocol + '//' + window.location.host;
  },
  getToken() {
    return new Promise((resolve, reject) => {
      let hostname = this.getHostname();

      try {
        const account = this.getAccount();

        $msalInstance
          ?.acquireTokenSilent({
            scopes: $scopes as string[],
            account,
            forceRefresh: false,
          })
          .then((tokenResponse) => {
            store.dispatch(SET_ACCOUNT, account);
            //TODO: set a timeout to renew token if now api will be called in the while
            resolve(tokenResponse.accessToken);
          })
          .catch(() => {
            hostname = this.getHostname();

            $msalInstance?.acquireTokenRedirect({
              scopes: $scopes as string[],
              redirectUri: hostname,
            });
            reject();
          });
      } catch {
        $msalInstance?.acquireTokenRedirect({
          scopes: $scopes as string[],
          redirectUri: hostname,
        });
        reject();
      }
    });
  },
  logout() {
    window.localStorage.setItem(LOGOUT_IN_PROGRESS, Date.now().toString());
    return $msalInstance?.logoutRedirect({
      account: store.state.account as AccountInfo,
    });
  },
};

export default service;
